var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.851562 10.9046C0.851562 4.88216 5.73345 3.24249e-05 11.7565 3.24249e-05C17.7782 3.24249e-05 22.6601 4.88216 22.6601 10.9046C22.6601 16.9269 17.7782 21.809 11.7565 21.809C5.73345 21.809 0.851562 16.9269 0.851562 10.9046Z",
    fill: "#D7D55A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54316 8.87557C8.54316 9.62346 8.18239 10.2299 7.73847 10.2299C7.29582 10.2299 6.93506 9.62346 6.93506 8.87557C6.93506 8.12768 7.29582 7.52116 7.73847 7.52116C8.18239 7.52116 8.54316 8.12768 8.54316 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.577 8.87557C16.577 9.62346 16.2176 10.2299 15.7736 10.2299C15.3297 10.2299 14.9702 9.62346 14.9702 8.87557C14.9702 8.12768 15.3297 7.52116 15.7736 7.52116C16.2176 7.52116 16.577 8.12768 16.577 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3516 14.3749C13.8516 17.0001 9.85156 17.0002 7.85156 14.375",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized6);
export default __webpack_public_path__ + "static/media/sylized_6.4cc36837547fa7377850d3855967c498.svg";
export { ForwardRef as ReactComponent };